import {
  DepositPaymentOption,
  DepositPaymentTargetAccount,
  isDefined,
  LoadableState,
  NbSelectItemOption,
} from '@eih-netbroker/common';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { CashActionNoSourceOrTargetAccountErrorFeedback } from '../common/CashActionNoSourceOrTargetAccountErrorFeedback';
import { CashActionParamEditor } from '../common/CashActionParamEditor';
import classes from './CashDepositParamEditorWrapper.module.scss';

type CashDepositParamEditorWrapperProps = {
  selectedInternalDetails: DepositPaymentOption | undefined;
  amount: string;
  noTargetAccountsAvailable: boolean;
  targetAccountAmount?: number;
  numberInputError?: string;
  selectedTargetAccount?: DepositPaymentTargetAccount;
  selectedCurrency: string;
  sourceAccountOptions?: LoadableState<Array<NbSelectItemOption<DepositPaymentTargetAccount>>>;
  targetAccountOptions?: LoadableState<Array<NbSelectItemOption<DepositPaymentTargetAccount>>>;
  handleAmountChange: (value: string) => void;
  handleSourceAccountChange?: (value: string | DepositPaymentTargetAccount) => void;
  handleTargetAccountChange: (value: DepositPaymentTargetAccount | string) => void;
};

export const CashDepositParamEditorWrapper = ({
  amount,
  handleAmountChange,
  handleTargetAccountChange,
  selectedInternalDetails,
  selectedTargetAccount,
  targetAccountOptions,
  selectedCurrency,
  numberInputError,
  noTargetAccountsAvailable,
}: CashDepositParamEditorWrapperProps) => {
  const { translation } = useLocale();

  if (!isDefined(selectedInternalDetails)) {
    return (
      <div className={classes.errorContainer}>
        <CashActionNoSourceOrTargetAccountErrorFeedback
          cashActionType="deposit"
          selectedCurrency={selectedCurrency}
        />
      </div>
    );
  }

  return (
    <CashActionParamEditor<string, DepositPaymentTargetAccount>
      amount={amount}
      cashActionType="deposit"
      numberInputError={numberInputError}
      handleAmountChange={handleAmountChange}
      selectedTargetAccount={selectedTargetAccount}
      selectedSourceAccount={selectedInternalDetails?.accountNumber}
      selectedCurrency={selectedCurrency}
      handleTargetAccountChange={handleTargetAccountChange}
      targetAccountOptions={targetAccountOptions}
      sourceAccountOptions={undefined}
      handleSourceAccountChange={undefined}
      sourceAccountAmount={selectedInternalDetails?.amount}
      targetAccountAmount={selectedTargetAccount?.amount}
      setAmountToMaxLabel={translation.cashAction.deposit.internal.totalDeposits}
      noTargetAccountsAvailable={noTargetAccountsAvailable}
    />
  );
};
